export interface LocationImportRequest {
    PostalCodes: string[] | undefined;
    ProductIds: string[] | undefined;
    TagIds: string[] | undefined;
    Day: number;
  }
  